<breadcrumb-navigation [titles]="[{ key: 'HOME_ECATALOG' | translate, url: '/ecatalog'},{ key: 'VEHICLE_SEARCH' | translate, url: ''}]" [needHome]="false"></breadcrumb-navigation>
<div class="vehicle-search-container">
    <!-- 车辆品牌 -->
    <div class="flex" *ngIf="stepName === 'brand'">
        <div class="brand-list w-40">
            <div
                *ngFor="let item of vehicleBrandList;"
                class="h-12 leading-12 border-b border-gray-100  px-4 text-center"
                [ngClass]="item.manuId === selectVehicle.manuId ? 'bg-white': 'bg-gray-100'"
                (click)="getVehicleSeries(item)"
            >
                {{ item.manuName }}
            </div>
        </div>
        <div class="grow brand-list">
            <div
                *ngFor="let item of vehicleSeriesList;"
                class="h-12 leading-12 border-b border-slate-100 px-4 "
                [ngClass]="item.id === selectVehicle.modelId ? 'bg-blue-50': 'bg-white'"
                (click)="handleViewVehicleVersion(item)"
            >
                {{ item.name }}({{ item.manufacturer || '--' }})
            </div>
        </div>
    </div>
    <!-- 版本 -->
    <div class="bg-gray-100 h-12 leading-12 text-center" *ngIf="stepName !== 'brand'">
        {{ selectVehicleParams }}
    </div>
    <div class="version-menu" *ngIf="stepName === 'version'">
        <div class="grow brand-list">
            <div
                *ngFor="let item of vehicleTypeList;"
                (click)="handleViewVehicleDisplace(item)"
                [ngClass]="item.description === selectVehicle.linkageTargetType ? 'bg-blue-50': 'bg-white'"
                class="h-12 leading-12 border-b border-slate-100 px-4 flex justify-between items-center"
            >
                <span>{{ item.description }} </span>
                <span nz-icon nzType="right" nzTheme="outline"></span>
            </div>
        </div>
    </div>
    <!-- 排量 -->
    <div class="type-menu" *ngIf="stepName === 'type'">
        <div class="grow brand-list">
            <div
                *ngFor="let item of vehicleDisplacementList;"
                (click)="handleViewVehicleYear(item)"
                [ngClass]="item === selectVehicle.displacement ? 'bg-blue-50': 'bg-white'"
                class="h-12 leading-12 border-b border-slate-100 px-4 flex justify-between items-center">
                <span>{{ item }} </span>
                <span nz-icon nzType="right" nzTheme="outline"></span>
            </div>
        </div>
    </div>
    <!-- 年款 -->
    <div class="year-menu"  *ngIf="stepName === 'year'">
        <div class="grow brand-list">
            <div
                *ngFor="let year of vehicleYearList;"
                (click)="handleSelectYears(year)"
                [ngClass]="year === selectVehicle.year ? 'bg-blue-50': 'bg-white'"
                class="h-12 leading-12 border-b border-slate-100 px-4 flex justify-between items-center">
                <span>{{ year }} </span>
                <span nz-icon nzType="right" nzTheme="outline"></span>
            </div>
        </div>
    </div>


    <div nz-row [nzGutter]="16" class="p-4 bg-white absolute bottom-0 left-0 z-30 w-full">
        <div nz-col nzSpan="12" (click)="handleCancel()">
            <div class="h-12 text-center flex justify-center items-center text-[#007BC0] border border-[#007BC0] bg-white">
                <span nz-icon nzType="close" nzTheme="outline" [nzTwotoneColor]="'#eb2f96'"></span>
                {{'CANCEL' | translate }}
            </div>
        </div>

        <div nz-col nzSpan="12" *ngIf="!showConfirmButton" (click)="handleSkip()">
            <div class="h-12 text-center flex justify-center items-center text-white bg-[#007BC0] border border-[#007BC0]">
                <svg-icon [iconName]="'new/arrow-right.svg'" [size]="24" class="mr6"></svg-icon>
                {{'SKIP' | translate }}
            </div>
        </div>

        <div nz-col nzSpan="12" *ngIf="showConfirmButton" >
            <div
                *ngIf="selectVehicle.modelId"
                (click)="handleConfirm()"
                class="h-12 text-center flex justify-center items-center text-white bg-[#007BC0] border border-[#007BC0]"
            >
                <span nz-icon nzType="check" nzTheme="outline"></span>
                {{'CONFIRM' | translate }}
            </div>
            <div
                *ngIf="!selectVehicle.modelId"
                class="h-12 text-center flex justify-center items-center text-white bg-[#c0c2c3] border border-[#c0c2c3]"
            >
                <span nz-icon nzType="check" nzTheme="outline"></span>
                {{'CONFIRM' | translate }}
            </div>
        </div>
      </div>
</div>
